import { Injectable } from '@angular/core';
import { Subject } from "rxjs";

@Injectable({ providedIn: 'root' })
export class SessionService {

  // Observable sources
  private countdownSource = new Subject<number>();
  private timeoutSource = new Subject<string>();
  private keepMeLoggedInSource = new Subject<string>();
  private idleEndedSource = new Subject<string>();

  // Observable streams
  countdown$: any = this.countdownSource.asObservable();
  timeout$: any = this.timeoutSource.asObservable();
  keepMeLoggedIn$: any = this.keepMeLoggedInSource.asObservable();
  idleEnded$: any = this.idleEndedSource.asObservable();

  // Service commands
  nextTick(tick: number) {
    this.countdownSource.next(tick);
  }

  timedOut() {
    this.timeoutSource.next("timedout");
  }

  keepMeLoggedIn() {
    this.keepMeLoggedInSource.next("keepMeLoggedIn");
  }

  onIdleEnd() {
    this.idleEndedSource.next("idle ended");
  }

}
